import { FC } from "react";
import { IFundSearchItemProps } from "./types";

const FundSearchItem: FC<IFundSearchItemProps> = ({ item }) => {
  return <span>{item.name}</span>;
};

export default FundSearchItem;
